// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"block-partner-module--logoContainer--2TBkd","logo":"block-partner-module--logo--1hm-D"};